import { Container } from "./StandaloneMessageStyles";

interface IStandaloneMessage {
  children: any;
}
function StandaloneMessage(props: IStandaloneMessage) {
  const { children } = props;
  return (
    <Container>
      <p className="standalone-message__title">{children}</p>
    </Container>
  );
}

export default StandaloneMessage;
